import { LoadingIcon } from '@/components/icons';

const LoadingPosts = () => (
  <div className="relative min-h-[400px] w-full">
    <LoadingIcon className="mx-auto h-10 w-10" />
  </div>
);

export default LoadingPosts;
